import {
    L2RCheckbox,
    Popover,
    styled,
} from "@l2r-front/l2r-ui"

export const Checkbox = styled(L2RCheckbox)(() => ({
    "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
}))

export const ContainerPopover = styled(Popover)(({ theme }) => ({
    direction: "rtl",
    pointerEvents: "auto",

    ".MuiPopover-paper": {
        paddingLeft: theme.spacing(4),
        borderRadius: theme.spacing(3),
    },
}))

export const CheckboxContainer = styled("div")(({ theme }) => ({
    direction: "ltr",
    pointerEvents: "auto",
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(1),
    overflowY: "auto",
}))